import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useInfiniteScroll } from "../Hooks/index.jsx";
import ExpenseModalContext from "../Tracking/context/ExpenseModalContext.js";

export const ExpenseModalContent = ({ children, onFetchMore, loadingNext, showLimitedAccess, cursorDate }) => {
  const ref = useRef();
  useInfiniteScroll(onFetchMore, 500, ref);

  return (
    <div
      className="tw-text-theme-900 tw-bg-page-paper-main tw-rounded-md tw-shadow-primary tw-overflow-auto"
      ref={ref}
    >
      <ExpenseModalContext.Provider
        value={{
          loadingNext,
          showLimitedAccess,
          cursorDate,
        }}
      >
        {children}
      </ExpenseModalContext.Provider>
    </div>
  );
};

ExpenseModalContent.propTypes = {
  onFetchMore: PropTypes.func,
  loadingNext: PropTypes.bool,
  showLimitedAccess: PropTypes.bool,
  cursorDate: PropTypes.number,
  children: PropTypes.node,
};
